<template>
  <div class="common-container">
    <van-image width="100%" fit="contain" :src="insureImgUrl" />
  </div>
</template>

<script>
import { getAggrementById } from "@/api/common";
export default {
  data() {
    return {
      insureImgUrl: "",
      categoryId: "",
      flag: 0,
    };
  },
  created() {
    let sId = this.$route.query.id || "";
    if (!this.$ComTools.isEmptyString(sId)) {
      this._getAggrementById(sId);
    }
  },
  methods: {
    _getAggrementById(id) {
      getAggrementById({ id: id }).then((res) => {
        let obj = res.data || {};
        document.title = obj.name;
        this.insureImgUrl = "/api/file" + obj.url;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-container {
  width: 100%;
  .button-save {
    /deep/ .van-button {
      background-color: transparent !important;
      border-color: transparent !important;
      color: #2440b3 !important;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/aggrement.vue